(function () {
  const todayIso = () => new Date().toISOString().slice(0, 10);
  const normalizePeriod = (value, fallback = todayIso().slice(0, 7)) => {
    const raw = String(value || '').trim();
    const match = raw.match(/^(\d{4})-(\d{2})/);
    return match ? `${match[1]}-${match[2]}` : fallback;
  };

  const defaultPaymentDateForPeriod = (period) => {
    const normalized = normalizePeriod(period);
    const [year, month] = normalized.split('-').map(Number);
    const lastDay = new Date(year, month, 0).getDate();
    return `${normalized}-${String(lastDay).padStart(2, '0')}`;
  };

  const monthDelta = (period, paymentDate) => {
    const normalizedPeriod = normalizePeriod(period);
    const normalizedDate = String(paymentDate || '').slice(0, 7);
    if (!/^\d{4}-\d{2}$/.test(normalizedDate)) return 0;
    const [periodYear, periodMonth] = normalizedPeriod.split('-').map(Number);
    const [dateYear, dateMonth] = normalizedDate.split('-').map(Number);
    return (dateYear - periodYear) * 12 + (dateMonth - periodMonth);
  };

  const hasUnusualPaymentDate = (period, paymentDate) => {
    const delta = monthDelta(period, paymentDate);
    return delta < 0 || delta > 1;
  };

  const paymentDateWarning = (period, paymentDate) => {
    if (!hasUnusualPaymentDate(period, paymentDate)) return '';
    return 'Utbetalingsdatoen er utenfor normal måned for lønnsperioden. Kontroller at lønnsperioden og datoen er riktig.';
  };

  const periodLabel = (period, locale = 'nb-NO') => {
    const normalized = normalizePeriod(period);
    const date = new Date(`${normalized}-01T00:00:00`);
    if (Number.isNaN(date.getTime())) return normalized;
    return date.toLocaleDateString(locale, { month: 'long', year: 'numeric' });
  };

  Object.assign(window, {
    PlummePayrollRunPeriod: {
      normalizePeriod,
      defaultPaymentDateForPeriod,
      monthDelta,
      hasUnusualPaymentDate,
      paymentDateWarning,
      periodLabel,
    },
  });
}());
